import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Response } from '@angular/http';

import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../reducers';

import { ErrorHandlerService, SponsorApi } from "../../services";
import { EventApi } from "../../services/webservice/event-api.service";
import { SponsorActions } from './sponsor.actions'
import { MessageActions } from '../../actions';
import { UnsafeAction } from "../../actions/UnsafeAction";
import * as moment from 'moment';


/* tslint:disable */
@Injectable()
export class SponsorEffects {
	constructor(
		private updates$: Actions,
		private state$: Store<AppState>,
		private sponsorApi: SponsorApi,
		private eventApi: EventApi,
		private sponsorActions: SponsorActions,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService,
	) {
	}

	@Effect() loadSponsorList$ = this.updates$
		.ofType(SponsorActions.LOAD_SPONSOR_LIST)
		.flatMap(() => this.sponsorApi.getSponsors()
			.map(sponsorList => this.sponsorActions.loadSponsorListSuccess(sponsorList)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))


	@Effect() loadSponsor$ = this.updates$
		.ofType(SponsorActions.LOAD_SPONSOR)
		.flatMap((action: UnsafeAction) => this.sponsorApi.loadSponsor(action.payload)
			.map(sponsor => this.sponsorActions.loadSponsorSuccess(sponsor))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() loadSponsorCodes$ = this.updates$
		.ofType(SponsorActions.LOAD_SPONSOR_CODES)
		.flatMap((action: UnsafeAction) => this.sponsorApi.getCodesForSponsor(action.payload)
			.map(sponsorCodes => this.sponsorActions.loadSponsorCodesSuccess(sponsorCodes)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadSponsorCodeById$ = this.updates$
		.ofType(SponsorActions.LOAD_SPONSOR_CODE_BY_ID)
		.flatMap((action: UnsafeAction) => this.sponsorApi.getSponsorCodeById(action.payload)
			.map(sponsorCode => this.sponsorActions.sponsorCodeLoaded(sponsorCode)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadSeatsByCodeUsageId$ = this.updates$
		.ofType(SponsorActions.LOAD_SEATS_BY_CODE_USAGE_ID)
		.flatMap((action: UnsafeAction) => this.sponsorApi.getSeatsByCodeUsageId(action.payload)
			.map(seats => this.sponsorActions.seatsForCodeUsageLoaded(seats)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadFreeSeatingsByCodeUsageId$ = this.updates$
		.ofType(SponsorActions.LOAD_FS_BY_CODE_USAGE_ID)
		.flatMap((action: UnsafeAction) => this.sponsorApi.getFreeSeatingsByCodeUsageId(action.payload)
			.map(freeSeatings => this.sponsorActions.freeSeatingsForCodeUsageLoaded(freeSeatings)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadSponsorCodeUsages$ = this.updates$
		.ofType(SponsorActions.LOAD_SPONSOR_CODE_USAGES)
		.flatMap((action: UnsafeAction) => this.sponsorApi.getCodeUsagesForSponsorCodeId(action.payload)
			.map(sponsorCodeUsages => this.sponsorActions.loadSponsorCodeUsagesSuccess(sponsorCodeUsages)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadSponsorCodeUsageById$ = this.updates$
		.ofType(SponsorActions.LOAD_SPONSOR_CODE_USAGE_BY_ID)
		.flatMap((action: UnsafeAction) => this.sponsorApi.getSponsorCodeUsageById(action.payload)
			.map(sponsorCodeUsage => this.sponsorActions.sponsorCodeUsageLoaded(sponsorCodeUsage)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadCodeUsageEventList$ = this.updates$
		.ofType(SponsorActions.LOAD_CODE_USAGE_EVENT_LIST)
		.flatMap(() => this.eventApi.getEventsForSponsoring()
			.map(events => {
				events.sort((a, b) => moment(a.begin, "YYYY-MM-DD'T'HH:mm:ss").diff(moment(b.begin, "YYYY-MM-DD'T'HH:mm:ss")));
				return this.sponsorActions.loadCodeUsageEventListSuccess(events)}))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	private handleError(error: Response, defaultMessage: string): Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error, defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}
}



// WEBPACK FOOTER //
// ./src/app/components/sponsors/sponsor.effects.ts